//
//  Services.js functions
//
//  standard request route
//  ../wp-json/wp/v2/service
//  request route for a ACF custom field NOTE: meta queries enabled in functions.php
//  e.g. ../wp-json/wp/v2/posts?filter[meta_key]=keyname&filter[meta_value]=keyvalue
//  http://mandm.thisislevel.nz/mandm_wp/wp-json/wp/v2/service/71 - returns all fields
//	http://mandm.thisislevel.nz/mandm_wp/wp-json/acf/v2/service/71 - returns just ACF fields
//  ?filter[meta_key]=keyname&filter[meta_value]=' + keyvalue

(function($) {

	//
	function set_selected_class($element){
		$(".sidebar-list-item").each(function() {
		    $(this).removeClass('sidebar-list-item-selected');	
		});
		$element.addClass('sidebar-list-item-selected');		
	}

	// 
	function populate_service(service_model){

        $( '.service-title' ).empty();
        $( '.service-subtitle' ).empty();
        $( '.service-description' ).empty();	
        $( '.service-quote' ).empty();	
        $( '.service-image' ).removeAttr('src');

        $( '.service-title' ).text( service_model.title.rendered  );
        $( '.service-subtitle' ).text( service_model.acf.service_subtitle );
        $( '.service-description' ).html( service_model.acf.service_description );	
        $( '.service-quote' ).text( service_model.acf.service_quote );	
        $( '.service-image' ).attr("src",  service_model.acf.service_image.url );	

	}

	//  
	var display_service = function display_service(service_id) {

		var auth = globals.make_basic_auth('webadmin','Lxl936q@');

	    $.ajax( {
	      	url: '/wp-json/wp/v2/service/' + service_id,
	      	dataType: 'text',
      	 	beforeSend : function(request) {
		        request.setRequestHeader('Authorization', auth);
		    },
	      	success: function(data, textStatus, request) {		        
		        //var json = JSON.parse(data);
		        var service_model = $.parseJSON(data);
		        populate_service(service_model);
	      	},
			error: function ( xhr, textStatus, errorThrown ) {
		        // display_error_message(xhr.responseText);
		        console.log(xhr.responseText);
		    }     
	    } );
	};	

	// 
	var get_default_service = function get_default_service() {

		var $service_id;
		var $selected_service_element;

		//  if we've come here from another page i.e. a service selected on the Home Page
		// the hidden field selected_service_id will be populated
		$selected_service_id = $( '#selected_service_id' ).val(); 
		// $( '#selected_service_id' );
		// console.log('selected_service_id : ' + $( '#selected_service_id' ).val());
		//
		if ($selected_service_id.length !== 0){
			$service_id = $selected_service_id;
			$selected_service_element = $("ul#sidebar-list").find("li#" + $selected_service_id);
			$( '#selected_service_id' ).val("");
		} else {
			$selected_service_element = $("ul#sidebar-list li:first");
			$service_id = $selected_service_element.attr("id");		
		}

		//
		set_selected_class($selected_service_element);	
		display_service($service_id);

	};

	$(document).ready(function(){
		//  select the 1st service by default when the form opens
		get_default_service();

		// 
		$(document).on("click",".sidebar-list-item",function() {
			$selected_item = $(this);
			var service_id = $selected_item.attr('id');
			//  display the news items for the clicked side bar button
			display_service(service_id);
			//
			set_selected_class($selected_item);
		});
	});

	// PUBLIC MEMBERS
	var services = {
		display_service: display_service,
		get_default_service: get_default_service
	};

	return services;		

})(jQuery);